type AssetObject = {
    src: string;
}

export type Asset = string|AssetObject;

function buildUrl(url: string): string {
    if (!url) {
        return url;
    }

    const publicCdnDomain = process.env.NEXT_PUBLIC_CDN_DOMAIN ?? process.env.PUBLIC_CDN_DOMAIN;
    const hasExternalCdn = (publicCdnDomain?.length ?? 0) > 0;
    if (!hasExternalCdn) {
        return url;
    }

    if (url.startsWith('/')) {
        return `${publicCdnDomain}${url}`;
    }

    return url;
}

/**
 * TODO
 * @category Utils
 */
export function getAssetSrc(asset: any): string|undefined {
    if (typeof asset === 'string') {
        return buildUrl(asset);
    }

    if (typeof asset === 'object' && typeof asset.src === 'string') {
        return buildUrl(asset.src);
    }

    return undefined;
}